module.exports = __webpack_public_path__ + "img/muziekvereniging-okk.de8b6812.jpg";